import { render, staticRenderFns } from "./ReminderChangeActivationType.vue?vue&type=template&id=d43138a8&"
import script from "./ReminderChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ReminderChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports